/*
 * 配送希望日・配送希望時間・配送地域（カートページ）
 * =====================================================================
 * 有料アプリ CC Delivery Date & Time の置き換え。
 * 商品DBの delivery_feed.php を読んで選択肢を組み立て、選ばれた内容を
 * カート属性として保存する。仕様は Obsidian「Shopify・配達日時指定の自前化仕様」。
 *
 * 【注文属性】5つ。名前も値の形式もフィードから受け取る（商品DBの配送設定が正）。
 *   配送希望日   … 2026年9月8日      （人が読む形）
 *   delivery_date … 2026/09/08        （ネクストエンジンが読む形）
 *   配送希望時間  … 14時から16時      （NEが「14時-16時」に変換して受け取る）
 *   delivery_time … 14時から16時
 *   配送地域     … 東京都
 *   ※未選択のときは日本語の2つに「指定しない」を入れ、英語2つと配送地域は空にする
 *     （現行アプリと同じ挙動。空文字を送るとShopifyは属性を消す）
 *
 * 【日付を自分で計算しない】
 *   選べる日付はサーバー（PHP）が作ってフィードに入っている。
 *   ここで new Date() から計算すると、お客さんの端末の時計とタイムゾーンで
 *   結果が変わってしまう。
 *
 * 【保存を2重にしている理由】
 *   ・/cart/update.js … 選んだ瞬間に保存。カート下部の追加決済ボタン
 *     （Amazon Pay等）でカートページを飛ばして決済に行っても値が残る
 *   ・hidden input（form="cart"）… 「購入手続きへ」の送信にも乗せる保険
 */
(function () {
  'use strict';

  var root = document.getElementById('cart-delivery');
  if (!root) return;

  var els = {
    fields: root.querySelector('[data-dv-fields]'),
    region: root.querySelector('[data-dv-region]'),
    date: root.querySelector('[data-dv-date]'),
    time: root.querySelector('[data-dv-time]'),
    timeField: root.querySelector('[data-dv-time-field]'),
    note: root.querySelector('[data-dv-note]'),
    hidden: root.querySelector('[data-dv-hidden-inputs]')
  };

  var feed = null;
  var UNSPECIFIED = '指定しない';

  // 取り寄せ商品を含むカートには、注文属性 `配送区分: 取り寄せ` を付ける。
  // ⚠️ 用途は2つ。
  //   ① 注文確認メールの文言を出し分ける（「発送準備を行っております」は取り寄せだと嘘になる）
  //   ② 出荷担当が注文の「追加詳細」を見た時点で取り寄せ品と分かる
  // 取り寄せを含まないときは空文字で送る（Shopifyは空文字の属性を消す）。
  var KIND_KEY = '配送区分';
  var kind = root.dataset.backorder === '1' ? '取り寄せ' : '';

  // フィードのURLに1分ごとに変わる値を付ける。
  // ⚠️ 2026-09-05: これが無いと、サーバーのCache-Controlが長いあいだ
  //    管理画面（配送設定）で変えた内容がカートに出てこない。
  //    URLが1分ごとに変わるので、サーバー側の設定に関係なく最大60秒で反映される。
  var feedUrl = root.dataset.feedUrl;
  feedUrl += (feedUrl.indexOf('?') === -1 ? '?' : '&') + 'm=' + Math.floor(Date.now() / 60000);

  fetch(feedUrl, { headers: { Accept: 'application/json' } })
    .then(function (res) {
      if (!res.ok) throw new Error('feed ' + res.status);
      return res.json();
    })
    .then(function (data) {
      // 商品DB側で配信を止めているときは何も出さない
      if (!data || data.enabled === false) return;
      feed = data;
      if (feed.unspecified) UNSPECIFIED = feed.unspecified;
      start();
    })
    .catch(function (e) {
      // フィードが取れないときは欄ごと出さない。カートは普通に使える
      if (window.console) console.warn('[cart-delivery] フィードを取得できませんでした', e);
    });

  function start() {
    var maxItems = parseInt(feed.clickpost_max_items, 10) || 0;
    var totalQty = parseInt(root.dataset.totalQty, 10) || 0;

    // 判定の優先順位: 取り寄せ > クリックポスト > 通常
    if (root.dataset.backorder === '1') {
      showReasonOnly(feed.notices && feed.notices.backorder);
      return;
    }
    if (root.dataset.clickpost === '1' && totalQty > 0 && totalQty <= maxItems) {
      showReasonOnly(feed.notices && feed.notices.clickpost);
      return;
    }
    buildFields();
  }

  /* 日時欄を出さない場合。理由を出し、属性は「指定しない」で揃える */
  function showReasonOnly(message) {
    var text = message || 'こちらのご注文は配達日時を指定できません。';
    els.note.textContent = text;
    els.note.hidden = false;
    root.hidden = false;
    save({ date: '', time: '', region: '' });
  }

  function buildFields() {
    var prefs = feed.prefectures || {};
    var names = Object.keys(prefs);
    if (!names.length) return;

    names.forEach(function (name) {
      els.region.appendChild(makeOption(name, name));
    });

    // 前回の選択 → 会員の登録住所 の順で初期値にする
    var initial = root.dataset.curRegion || root.dataset.defaultRegion || '';
    if (initial && prefs[initial] !== undefined) {
      els.region.value = initial;
    }

    els.region.addEventListener('change', function () {
      fillDateAndTime();
      save(currentValues());
    });
    els.date.addEventListener('change', function () { save(currentValues()); });
    els.time.addEventListener('change', function () { save(currentValues()); });

    if (els.region.value) fillDateAndTime();

    renderNotes();
    els.fields.hidden = false;
    root.hidden = false;
    syncHiddenInputs(currentValues());

    // 取り寄せ品をカートから外した後などに、古い `配送区分` が残らないようにする。
    // 値が実態と違うときだけ保存するので、毎回の読み込みで通信は発生しない。
    if ((root.dataset.curKind || '') !== kind) {
      save(currentValues());
    }
  }

  /* 都道府県 → グループ → その地域で選べる日付と時間帯 */
  function fillDateAndTime() {
    var region = els.region.value;
    var group = region ? (feed.groups || {})[String((feed.prefectures || {})[region])] : null;

    clearOptions(els.date);
    clearOptions(els.time);

    if (!group) {
      els.date.appendChild(makeOption('', '先に都道府県を選んでください'));
      els.time.appendChild(makeOption('', '先に都道府県を選んでください'));
      els.date.disabled = true;
      els.time.disabled = true;
      return;
    }

    els.date.appendChild(makeOption('', UNSPECIFIED));
    (group.dates || []).forEach(function (d) {
      els.date.appendChild(makeOption(d.v, d.label));
    });
    els.date.disabled = false;
    if (root.dataset.curDate) els.date.value = root.dataset.curDate;

    // 沖縄・離島など、時間帯を指定できない地域では時間欄ごと隠す
    if (group.allow_time === false) {
      els.timeField.hidden = true;
      els.time.disabled = true;
      return;
    }
    els.timeField.hidden = false;
    els.time.appendChild(makeOption('', UNSPECIFIED));
    (feed.times || []).forEach(function (t) {
      els.time.appendChild(makeOption(t, t));
    });
    els.time.disabled = false;
    if (root.dataset.curTime) els.time.value = root.dataset.curTime;
  }

  function renderNotes() {
    var list = (feed.notices && feed.notices.note) || [];
    if (!list.length) return;
    els.note.textContent = '';
    list.forEach(function (body) {
      var p = document.createElement('p');
      p.className = 'cart-delivery__note-line';
      p.textContent = body;
      els.note.appendChild(p);
    });
    els.note.hidden = false;
  }

  function currentValues() {
    var opt = els.date.options[els.date.selectedIndex];
    return {
      date: els.date.value || '',
      dateLabel: (els.date.value && opt) ? opt.textContent : '',
      time: (els.timeField.hidden ? '' : (els.time.value || '')),
      region: els.region.value || ''
    };
  }

  /* カート属性に保存する。空文字を送るとShopifyはその属性を消す */
  function save(v) {
    var a = feed.attributes || {};
    var body = {};
    body[a.date_ja || '配送希望日'] = v.date ? (v.dateLabel || v.date) : UNSPECIFIED;
    body[a.date_en || 'delivery_date'] = v.date || '';
    body[a.time_ja || '配送希望時間'] = v.time || UNSPECIFIED;
    body[a.time_en || 'delivery_time'] = v.time || '';
    body[a.region || '配送地域'] = v.region || '';
    body[KIND_KEY] = kind;

    syncHiddenInputs(v);

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: body })
    }).catch(function (e) {
      if (window.console) console.warn('[cart-delivery] カート属性を保存できませんでした', e);
    });
  }

  /* 「購入手続きへ」の送信にも同じ値を乗せる（form="cart"） */
  function syncHiddenInputs(v) {
    var a = feed.attributes || {};
    var pairs = [
      [a.date_ja || '配送希望日', v.date ? (v.dateLabel || v.date) : UNSPECIFIED],
      [a.date_en || 'delivery_date', v.date || ''],
      [a.time_ja || '配送希望時間', v.time || UNSPECIFIED],
      [a.time_en || 'delivery_time', v.time || ''],
      [a.region || '配送地域', v.region || ''],
      [KIND_KEY, kind]
    ];
    els.hidden.textContent = '';
    pairs.forEach(function (p) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'attributes[' + p[0] + ']';
      input.value = p[1];
      input.setAttribute('form', 'cart');
      els.hidden.appendChild(input);
    });
  }

  function makeOption(value, label) {
    var o = document.createElement('option');
    o.value = value;
    o.textContent = label;
    return o;
  }

  function clearOptions(select) {
    while (select.firstChild) select.removeChild(select.firstChild);
  }
})();
